import React, { useEffect, useState } from "react";
import assets from "../../../../../assets/assets";
import { IconController } from "../../../../Scripts/ImgController";
const SelectSecondaryGenres = ({ genreInformation, setGenreChanged, secondaryGenres, primaryGenre }) => {
   const [genreSelected, setGenreSelected] = useState(false);
   const [genreIsPrimary, setGenreIsPrimary] = useState(false);
   useEffect(() => {
      secondaryGenres.map((a) => {
         if (a.id === genreInformation.id) {
            setGenreSelected(true);
         }
      });
      if (primaryGenre.id === genreInformation.id) {
         setGenreIsPrimary(true);
      }
   }, []);

   const genreUncheckHandler = (id) => {
      const index = secondaryGenres.findIndex((object) => {
         return object.id === id;
      });
      if (index > -1) {
         secondaryGenres.splice(index, 1);
      }
      setGenreSelected(false);
      setGenreChanged(true);
   };
   const genreCheckHandler = (genreInformation) => {
      secondaryGenres.push(genreInformation);
      setGenreSelected(true);
      setGenreChanged(true);
   };
   return (
      <div className="flex flex-row items-center gap-2">
         {genreIsPrimary ? (
            <IconController src={assets.svg.genreCrown} className="w-5 h-5 cursor-not-allowed" />
         ) : (
            <>
               {genreSelected ? (
                  <div
                     onClick={() => {
                        genreUncheckHandler(genreInformation.id);
                     }}
                  >
                     <IconController src={assets.svg.checkboxChecked} className="w-5 h-5 cursor-pointer" />
                  </div>
               ) : (
                  <div
                     className="checkbox-unchecked"
                     onClick={() => {
                        genreCheckHandler(genreInformation);
                     }}
                  ></div>
               )}
            </>
         )}

         <h5 className="text-xs flex-1">{genreInformation.name}</h5>
      </div>
   );
};

export default SelectSecondaryGenres;
